/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Transfer describes a set of files and metadata submitted by a GSA to SDPS for processing.
 * @export
 * @interface FileFormatCategoryChange
 */
export interface FileFormatCategoryChange {
    /**
     * Batch that contained this content
     * @type {number}
     * @memberof FileFormatCategoryChange
     */
    batchId?: number;
    /**
     * 
     * @type {Date}
     * @memberof FileFormatCategoryChange
     */
    createdAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof FileFormatCategoryChange
     */
    id: number;
    /**
     * url/location of file format category lists
     * @type {string}
     * @memberof FileFormatCategoryChange
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof FileFormatCategoryChange
     */
    status: FileFormatCategoryChangeStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof FileFormatCategoryChange
     */
    statusUpdatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof FileFormatCategoryChange
     */
    versionNumber?: number;
}


/**
 * @export
 */
export const FileFormatCategoryChangeStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type FileFormatCategoryChangeStatusEnum = typeof FileFormatCategoryChangeStatusEnum[keyof typeof FileFormatCategoryChangeStatusEnum];


/**
 * Check if a given object implements the FileFormatCategoryChange interface.
 */
export function instanceOfFileFormatCategoryChange(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function FileFormatCategoryChangeFromJSON(json: any): FileFormatCategoryChange {
    return FileFormatCategoryChangeFromJSONTyped(json, false);
}

export function FileFormatCategoryChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileFormatCategoryChange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batchId': !exists(json, 'batch_id') ? undefined : json['batch_id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'id': json['id'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
        'versionNumber': !exists(json, 'version_number') ? undefined : json['version_number'],
    };
}

export function FileFormatCategoryChangeToJSON(value?: FileFormatCategoryChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch_id': value.batchId,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'location': value.location,
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
        'version_number': value.versionNumber,
    };
}

